var React = require('react');

function Mitten (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M368 416a16 16 0 0 1 16 16v64a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16v-64a16 16 0 0 1 16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M433.12 297l-72.5 87h-309L3.72 176.42a144 144 0 0 1 107.9-172.7c77.4-17.9 154.8 30.5 172.8 108L314 240.12l20.9-25a63.94 63.94 0 1 1 98.2 81.9z","className":"fa-primary","key":2})]);
}

Mitten.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Mitten;

Mitten.default = Mitten;
